const actions = {
    UPLOAD_START: 'UPLOAD_START',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'UPLOAD_FAILURE',

    GET_FILE_START: 'GET_FILE_START',
    GET_FILE_SUCCESS: 'GET_FILE_SUCCESS',
    GET_FILE_FAILURE: 'GET_FILE_FAILURE',

    CLEAR_UPLOAD_START: 'CLEAR_UPLOAD_START',
    CLEAR_UPLOAD_SUCCESS: 'CLEAR_UPLOAD_SUCCESS'
};

export default actions;